import * as React from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";

import Redirect from "components/Redirect";
import { SettingsSection } from "constants/settings/sections";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import useSettingsSection from "hooks/settings/use-settings-section";
import { canManageApplications } from "store/entities/applications";

import { SettingsRoutes } from "../constants";

import { LivechatSettingsPage } from "./pages/Livechat/LivechatSettingsPage";
import { MainPage } from "./pages/Main";
import { NoMobile } from "./pages/NoMobile";
import { ApplicationSettings } from "./pages/Settings";
import { ZapierSettings } from "./pages/Zapier";

const IntegrationsRouter: React.FC<IWithBreakpointsProps> = ({ isDesktop }) => {
  useSettingsSection(SettingsSection.Integrations);

  const canManageApps = useSelector(canManageApplications);

  return (
    <Switch>
      {canManageApps && isDesktop && (
        <Route path={`${SettingsRoutes.Integrations}/apps/zapier`} component={ZapierSettings} />
      )}
      {canManageApps && isDesktop && (
        <Route path={`${SettingsRoutes.Integrations}/apps/livechat`} component={LivechatSettingsPage} />
      )}
      {canManageApps && isDesktop && (
        <Route path={`${SettingsRoutes.Integrations}/apps/:slug`} component={ApplicationSettings} />
      )}
      {isDesktop && <Route exact path={`${SettingsRoutes.Integrations}/:slug`} component={MainPage} />}
      {!isDesktop && <Route path={`${SettingsRoutes.Integrations}/installed`} component={NoMobile} />}
      <Redirect to={`${SettingsRoutes.Integrations}/installed`} />
    </Switch>
  );
};

export default withBreakpoints(IntegrationsRouter);
